







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Allergencode, Allergencodes } from './Allergencode';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component
export default class ProductInformation extends Vue {
  @Prop()
  public localDescription: string;
  @Prop()
  public localAllergenInfo: string;
  @Prop()
  public localStorageNote: string;
  @Prop()
  public localIngredients: string;
  @Prop()
  public localSku: string;

  get datasheetUrl(): string {
    return `/product/datasheet/${this.localSku}`;
  }

  public getAllergenLabel(index): string {
    return this.$t(Allergencodes.getNameKey(index).toLowerCase()).toString();
  }

  public getAllergenIconName(index): string {
    return '/images/allergens/' + Allergencode[index].toLowerCase() + '.png';
  }

  public trackDatasheetDownload() {
    MatomoEvents.forDatasheet.download.publish();
  }
}
